"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMessage = void 0;
function getMessage(messageMap, defaultMsg, key) {
    var defaultResponse = { ecomm: defaultMsg, pos: defaultMsg, source: undefined };
    if (!key) {
        return defaultResponse;
    }
    var message = messageMap.get(key);
    return message !== undefined ? message : defaultResponse;
}
exports.getMessage = getMessage;
